import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "absolute z-20 w-full overflow-y-scroll border-t border-b-2 border-r shadow-xl border-b-black h-fit top-24 md:top-20 md:block xl:w-96 bg-play-gray border-play-light-gray"
}
const _hoisted_3 = { class: "font-medium" }
const _hoisted_4 = { class: "uppercase" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  width: "15",
  height: "9",
  viewBox: "0 0 15 9",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "mt-1"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1 1L7.5 7.5L14 1",
    stroke: "#000000",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "font-medium" }
const _hoisted_9 = { class: "capitalize" }
const _hoisted_10 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "15",
  height: "11",
  viewBox: "0 0 15 11",
  fill: "none"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("path", {
  d: "M14.26.481a.964.964 0 0 1 0 1.407l-8 8a.964.964 0 0 1-1.406 0l-4-4a.964.964 0 0 1 0-1.407.964.964 0 0 1 1.407 0l3.281 3.282L12.855.48a.964.964 0 0 1 1.406 0Z",
  fill: "#000"
}, null, -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = ["href"]
const _hoisted_14 = { class: "pl-2 ml-auto" }
const _hoisted_15 = ["href", "aria-label"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0v-5z"
  })
], -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = ["onClick", "aria-label"]
const _hoisted_19 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "ml-auto",
  viewBox: "0 0 24 24"
}
const _hoisted_20 = /*#__PURE__*/_createStaticVNode("<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2.4 5L0 7.33333L9.6 16.6667L12 19L14.4 16.6667L24 7.33333L21.6 5L12 14.3333L2.4 5Z\" fill=\"black\"></path><mask id=\"mask0_0_4024\" style=\"mask-type:luminance;\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"5\" width=\"16\" height=\"14\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2.4 5L0 7.33333L9.6 16.6667L12 19L14.4 16.6667L24 7.33333L21.6 5L12 14.3333L2.4 5Z\" fill=\"white\"></path></mask><g mask=\"url(#mask0_0_4024)\"><rect width=\"16\" height=\"16\" fill=\"black\"></rect></g>", 3)
const _hoisted_23 = [
  _hoisted_20
]
const _hoisted_24 = {
  key: 1,
  width: "16",
  class: "ml-auto",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_25 = /*#__PURE__*/_createStaticVNode("<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21.6 19L24 16.6667L14.4 7.33333L12 5L9.6 7.33333L0 16.6667L2.4 19L12 9.66667L21.6 19Z\" fill=\"black\"></path><mask id=\"mask0_0_4033\" style=\"mask-type:luminance;\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"5\" width=\"16\" height=\"14\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21.6 19L24 16.6667L14.4 7.33333L12 5L9.6 7.33333L0 16.6667L2.4 19L12 9.66667L21.6 19Z\" fill=\"white\"></path></mask><g mask=\"url(#mask0_0_4033)\"><rect width=\"16\" height=\"16\" fill=\"black\"></rect></g>", 3)
const _hoisted_28 = [
  _hoisted_25
]
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { class: "hidden w-48 h-full border-t border-r md:block xl:w-96 bg-play-gray top-32 border-play-light-gray" }
const _hoisted_31 = ["href", "aria-label"]
const _hoisted_32 = { class: "pl-2 ml-auto" }
const _hoisted_33 = ["href", "aria-label"]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0v-5z"
  })
], -1)
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = ["onClick", "aria-label"]
const _hoisted_37 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "ml-auto",
  viewBox: "0 0 24 24"
}
const _hoisted_38 = /*#__PURE__*/_createStaticVNode("<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2.4 5L0 7.33333L9.6 16.6667L12 19L14.4 16.6667L24 7.33333L21.6 5L12 14.3333L2.4 5Z\" fill=\"black\"></path><mask id=\"mask0_0_4024\" style=\"mask-type:luminance;\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"5\" width=\"16\" height=\"14\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2.4 5L0 7.33333L9.6 16.6667L12 19L14.4 16.6667L24 7.33333L21.6 5L12 14.3333L2.4 5Z\" fill=\"white\"></path></mask><g mask=\"url(#mask0_0_4024)\"><rect width=\"16\" height=\"16\" fill=\"black\"></rect></g>", 3)
const _hoisted_41 = [
  _hoisted_38
]
const _hoisted_42 = {
  key: 1,
  width: "16",
  class: "ml-auto",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_43 = /*#__PURE__*/_createStaticVNode("<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21.6 19L24 16.6667L14.4 7.33333L12 5L9.6 7.33333L0 16.6667L2.4 19L12 9.66667L21.6 19Z\" fill=\"black\"></path><mask id=\"mask0_0_4033\" style=\"mask-type:luminance;\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"5\" width=\"16\" height=\"14\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21.6 19L24 16.6667L14.4 7.33333L12 5L9.6 7.33333L0 16.6667L2.4 19L12 9.66667L21.6 19Z\" fill=\"white\"></path></mask><g mask=\"url(#mask0_0_4033)\"><rect width=\"16\" height=\"16\" fill=\"black\"></rect></g>", 3)
const _hoisted_46 = [
  _hoisted_43
]
const _hoisted_47 = { key: 0 }

import { PropType, ref, onMounted, watch, computed } from "vue";
import { useRouter } from "vue-router";
import { storeToRefs } from "pinia";
import { useI18n } from "vue-i18n";

import { useGlobalStore } from "@/store";
import { getUsersHighestRole, userHasRole } from "@/utils/roles";


export default /*#__PURE__*/_defineComponent({
  __name: 'SideBar',
  props: {
  user: {
    type: Object as PropType<any>,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const router = useRouter();


const effectiveRoles = computed(() => {
  return props.user.roles.map((role: any) =>
    role.name === "l4a-trainee"
      ? { ...role, name: "advanced-facilitator" }
      : role
  );
});

const showSidebar = ref(false);
const subMenus = ref({} as { [key: string]: boolean });
const isLanguageMenuOpen = ref(false);

const { locale } = useI18n({
  useScope: "global",
});
const { isMobileMenuOpen, currentLanguage, languages } = storeToRefs(useGlobalStore());

const hideSubscriptionRoles = ["professional", "paid-professional", "parent", "brick-club-family"];

const allRoles = [
  "admin",
  "trainer-organisation",
  "professional",
  "paid-professional",
  "l4a-trainer",
  "l4a-trainee",
  "advanced-facilitator-trainee",
  "advanced-facilitator",
  "certified-facilitator-trainee",
  "certified-facilitator",
  "courses-admin",
  "users-admin",
  "clubs-admin",
  "parent",
  "brick-club-family",
  "facilitator-organisation",
];

const routes = [
  {
    name: "dashboard",
    path: `/dashboard`,
    roles: allRoles,
    ariaLabel: "Dashboard menu",
    subNav: [
      {
        name: "orders",
        path: `/dashboard/orders?page=1`,
        roles: ["admin"],
      },
      {
        name: "licences",
        path: `/dashboard/licences?page=1`,
        roles: ["admin"],
      },
      {
        name: "subscriptions",
        path: `/dashboard/subscriptions?page=1`,
        roles: ["admin"],
      },
      {
        name: "website-data",
        path: `/dashboard/websitedata`,
        roles: ["admin", "courses-admin", "users-admin", "clubs-admin"],
      },
    ],
  },
  {
    name: "users",
    path: `/dashboard/users?page=1`,
    roles: ["admin", "users-admin"],
    ariaLabel: "Users menu",
    subNav: [
      {
        name: "trained-by-organisations",
        path: `/dashboard/organisations?page=1`,
        roles: ["admin", "users-admin", "courses-admin"],
      },
      {
        name: "user-groups",
        path: `/dashboard/user-groups`,
        roles: ["admin", "users-admin", "courses-admin"],
      },
    ],
  },
  {
    name: "users",
    path: "/dashboard/users?page=1",
    roles: ["trainer-organisation", "facilitator-organisation"],
  },
  {
    name: "courses",
    path: `/dashboard/courses`,
    roles: allRoles.filter(i => !["parent", "brick-club-family", "trainer-organisation", "facilitator-organisation"].includes(i)),
    ariaLabel: "Courses menu",
    subNav: [
      {
        name: "course-templates",
        path: `/dashboard/courses/templates`,
        roles: ["admin", "courses-admin"],
      },
      {
        name: "add-a-new-event",
        path: `/dashboard/courses/events/new?`,
        roles: ["admin", "l4a-trainer", "trainer-organisation", "courses-admin"],
      },
      {
        name: "training-courses",
        path: `/dashboard/courses/events?page=1`,
        roles: ["admin", "l4a-trainer", "trainer-organisation", "courses-admin", "facilitator-organisation"],
      },
      {
        name: "discounts",
        path: `/dashboard/courses/discounts?page=1`,
        roles: ["admin"],
      },
      {
        name: "completion-record-certificates",
        path: `/dashboard/courses/certificates?page=1`,
        roles: ["certified-facilitator", "advanced-facilitator-trainee", "advanced-facilitator", "l3-specialist", "l4a-trainer", "l4b-mentor", "l4a-trainee"],
      },
    ],
  },
  {
    name: "brick-clubs",
    path: `/dashboard/clubs`,
    hidden: process.env.VUE_APP_BRICK_CLUBS_ENABLED === "false",
    roles: [
      "admin",
      "advanced-facilitator",
      "certified-facilitator",
      "advanced-facilitator-trainee",
      "clubs-admin",
      "brick-club-family",
      "facilitator-organisation"
    ],
  },
  // {
  //   name: "member-outcomes",
  //   path: `/dashboard/club-member-outcomes`,
  //   roles: ["advanced-facilitator", "facilitator-organisation", "trainer-organisation"],
  // },
  {
    name: "my-children",
    path: `/dashboard/children`,
    roles: ["brick-club-family"],
  },
  {
    name: "child-outcomes",
    path: `/dashboard/children/outcomes`,
    roles: ["brick-club-family"],
  },
  {
    name: "training-feedback",
    path: `/dashboard/training-feedback`,
    roles: ["admin", "l4a-trainer", "trainer-organisation", "courses-admin"],
  },
  {
    name: "resources",
    path: `/dashboard/resources?page=1`,
    roles: allRoles,
  },
  {
    name: "website",
    path: `https://app.storyblok.com/#/login`,
    roles: ["admin"],
    externalLink: true,
  },
  {
    name: "community",
    path: `https://www.facebook.com/groups/186528913182884/`,
    roles: ["certified-facilitator", "advanced-facilitator", "l4a-trainee", "l4a-trainer", "l4b-trainee", "l4b-mentor", "trainer-organisation", "facilitator-organisation"],
    externalLink: true,
  },

  {
    name: "email-marketing",
    path: `https://www.brevo.com/`,
    roles: ["admin"],
    externalLink: true,
  },
  {
    name: "my-profile",
    path: `/dashboard/profile`,
    roles: allRoles,
    ariaLabel: "Profile menu",
    subNav: [
      {
        name: "subscription",
        path: `/dashboard/profile/subscription`,
        roles: allRoles.filter(i => !hideSubscriptionRoles.includes(i)),
      },
      {
        name: "account-security",
        path: `/dashboard/profile/security`,
        roles: allRoles,
      },
      {
        name: "email-preferences",
        path: `/dashboard/profile/email-preferences`,
        roles: allRoles,
      },
    ],
  },
  {
    name: "get-help",
    path: `${process.env.VUE_APP_WEBSITE_URL}/contact-us/`,
    roles: allRoles.filter(i => i !== "admin"),
    externalLink: true,
  },
  {
    name: "logout",
    path: `/logout`,
    roles: allRoles,
  },
];

const currentRouteName = ref("");
const currentRoute = router.currentRoute.value.fullPath;

function userCanSeeToggle(routeName: string) {
  const r = routes.find(i => i.name === routeName)!;

  const userRole = getUsersHighestRole(effectiveRoles.value);
  return r.subNav?.find(i => i.roles.includes(userRole.name));
}

function setLang(lang: any) {
  currentLanguage.value = lang;
  locale.value = lang.i18n;
}

function toggleMenu(index: string) {
  subMenus.value[index] = !subMenus.value[index];
}

routes.map(route => {
  if (route.subNav) {
    subMenus.value[route.name] = false;
  }
});

onMounted(() => {
  /** FOs will see a different menu to normal users, so we replace "Courses" section with just "Training Courses" */
  if (effectiveRoles.value.find((i: any) => i.name === "facilitator-organisation")) {
    const coursesIndex = routes.findIndex(i => i.name === "courses");
    routes[coursesIndex] = {
      name: "training-courses",
      path: `/dashboard/courses/events?page=1`,
      roles: ["admin", "l4a-trainer", "trainer-organisation", "courses-admin", "facilitator-organisation"],
    };
  }

  if (userHasRole(effectiveRoles.value, ["trainer-organisation", 'l4a-trainee', 'l4a-trainer'])) {
    const coursesIndex = routes.findIndex(i => i.name === "courses");
    routes[coursesIndex] = {
      name: "training-courses",
      path: `/dashboard/courses/events?page=1`,
      roles: ["admin", "l4a-trainer", "trainer-organisation", "courses-admin", "facilitator-organisation"],
      ariaLabel: "Training Courses menu",
      subNav: [
        {
          name: "add-a-new-event",
          path: `/dashboard/courses/events/new?`,
          roles: ["admin", "l4a-trainer", "trainer-organisation", "courses-admin"],
        },
      ],
    };
  }

  /** Finds the current route is located on sidebar and opens the corresponding subMenu */
  routes.map(route => {
    if (Object.keys(route).includes("subNav")) {
      if (route.subNav?.find(i => i.name === currentRouteName.value)) {
        subMenus.value[route.name] = true;
      }
    }
  });

  showSidebar.value = true;
});

watch(router.currentRoute, () => {
  currentRouteName.value = router.currentRoute.value.name?.toString().toLocaleLowerCase()!;
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (showSidebar.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_unref(isMobileMenuOpen))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "fixed z-10 w-full h-full bg-black bg-opacity-50 top-24 md:top-20 md:hidden xl:hidden",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (isMobileMenuOpen.value = false))
            }))
          : _createCommentVNode("", true),
        (_unref(isMobileMenuOpen))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", {
                class: _normalizeClass([isLanguageMenuOpen.value ? 'border-t border-t-black' : 'border-y border-y-black', 'flex items-center px-8 py-3 font-medium text-black '])
              }, [
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (isLanguageMenuOpen.value = !isLanguageMenuOpen.value)),
                  class: "flex items-center justify-between w-full"
                }, [
                  _createElementVNode("span", _hoisted_3, [
                    _createElementVNode("strong", _hoisted_4, _toDisplayString(_unref(currentLanguage).locale), 1),
                    _createTextVNode(" - " + _toDisplayString(_unref(currentLanguage).name), 1)
                  ]),
                  _hoisted_5
                ])
              ], 2),
              (isLanguageMenuOpen.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("ul", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(languages), (lang, index) => {
                        return (_openBlock(), _createElementBlock("li", {
                          class: "flex items-center px-8 py-3 font-medium text-black border-b border-gray-300 text-decoration-none last:border-b last:border-b-black",
                          key: index
                        }, [
                          _createElementVNode("button", {
                            class: "flex items-center justify-between w-full",
                            onClick: ($event: any) => (setLang(lang))
                          }, [
                            _createElementVNode("span", _hoisted_8, [
                              _createElementVNode("strong", _hoisted_9, _toDisplayString(_ctx.$t(lang.region)), 1),
                              _createTextVNode(" - " + _toDisplayString(_ctx.$t(lang.name)), 1)
                            ]),
                            (_unref(currentLanguage).name === lang.name)
                              ? (_openBlock(), _createElementBlock("svg", _hoisted_10, _hoisted_12))
                              : _createCommentVNode("", true)
                          ], 8, _hoisted_7)
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(routes.filter(i => !i.hidden && _unref(effectiveRoles).find((k) => i.roles.includes(k.name))), (route) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: route.name
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["flex items-center px-8 py-3 font-medium text-black border-b border-gray-300 text-decoration-none", {
            'border-l-2 border-black':
              (_unref(router).currentRoute.value.fullPath === route.path && route.name !== 'Dashboard') ||
              (_unref(router).currentRoute.value.fullPath === '/dashboard' && route.name === 'Dashboard'),
          }])
                  }, [
                    (!route.externalLink)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: route.path,
                          class: "w-full capitalize"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t(`${route.name}`)), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      : _createCommentVNode("", true),
                    (route.externalLink)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          href: route.path,
                          target: "_blank"
                        }, _toDisplayString(_ctx.$t(`${route.name}`)), 9, _hoisted_13))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_14, [
                      (route.externalLink)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            href: route.path,
                            target: "_blank",
                            "aria-label": _ctx.$t('external-link')
                          }, _hoisted_17, 8, _hoisted_15))
                        : _createCommentVNode("", true)
                    ]),
                    (userCanSeeToggle(route.name))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 2,
                          onClick: ($event: any) => (toggleMenu(route.name)),
                          class: "ml-auto",
                          "aria-label": subMenus.value[route.name] ? _ctx.$t('collapse') + ' ' + route.ariaLabel : _ctx.$t('expand') + ' ' + route.ariaLabel
                        }, [
                          (route.subNav && subMenus.value[route.name])
                            ? (_openBlock(), _createElementBlock("svg", _hoisted_19, _hoisted_23))
                            : _createCommentVNode("", true),
                          (route.subNav && !subMenus.value[route.name])
                            ? (_openBlock(), _createElementBlock("svg", _hoisted_24, _hoisted_28))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_18))
                      : _createCommentVNode("", true)
                  ], 2),
                  (subMenus.value[route.name] && route.subNav)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(route.subNav.filter(i => _unref(effectiveRoles).find((k) => i.roles.includes(k.name))), (subRoute) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: subRoute.name
                          }, [
                            _createVNode(_component_router_link, {
                              class: _normalizeClass(["flex items-center py-3 pl-12 pr-8 font-medium text-black capitalize border-b border-gray-300 text-decoration-none", {
                'border-l-2 border-black':
                  (_unref(currentRoute).includes(subRoute.path) && subRoute.name !== 'Dashboard') || (_unref(currentRoute) === '/dashboard' && subRoute.name === 'Dashboard'),
              }]),
                              to: subRoute.path
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t(`${subRoute.name}`)), 1)
                              ]),
                              _: 2
                            }, 1032, ["class", "to"])
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_30, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(routes.filter(i => !i.hidden && _unref(effectiveRoles).find((k) => i.roles.includes(k.name))), (route) => {
            return (_openBlock(), _createElementBlock("div", {
              key: route.name
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["flex items-center px-8 py-3 font-medium text-black text-decoration-none", currentRouteName.value.includes(route.name.toLowerCase()) ? 'border-l-2 border-b border-black' : 'border-b border-gray-300'])
              }, [
                (!route.externalLink)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: route.path,
                      class: "w-full capitalize"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t(`${route.name}`)), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  : _createCommentVNode("", true),
                (route.externalLink)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      href: route.path,
                      target: "_blank",
                      "aria-label": _ctx.$t(`${route.name}`) + ' (' + _ctx.$t('external-link') + ')'
                    }, _toDisplayString(_ctx.$t(`${route.name}`)), 9, _hoisted_31))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_32, [
                  (route.externalLink)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: route.path,
                        target: "_blank",
                        "aria-label": _ctx.$t('external-link')
                      }, _hoisted_35, 8, _hoisted_33))
                    : _createCommentVNode("", true)
                ]),
                (userCanSeeToggle(route.name))
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 2,
                      onClick: ($event: any) => (toggleMenu(route.name)),
                      class: "ml-auto",
                      "aria-label": subMenus.value[route.name] ? _ctx.$t('collapse') + ' ' + route.ariaLabel : _ctx.$t('expand') + ' ' + route.ariaLabel
                    }, [
                      (route.subNav && !subMenus.value[route.name])
                        ? (_openBlock(), _createElementBlock("svg", _hoisted_37, _hoisted_41))
                        : _createCommentVNode("", true),
                      (route.subNav && subMenus.value[route.name])
                        ? (_openBlock(), _createElementBlock("svg", _hoisted_42, _hoisted_46))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_36))
                  : _createCommentVNode("", true)
              ], 2),
              (subMenus.value[route.name] && route.subNav)
                ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(route.subNav.filter(i => _unref(effectiveRoles).find((k) => i.roles.includes(k.name))), (subRoute) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: subRoute.name
                      }, [
                        _createVNode(_component_router_link, {
                          class: _normalizeClass(["flex items-center py-3 pl-12 pr-8 font-medium text-black capitalize text-decoration-none", currentRouteName.value === subRoute.name.toLowerCase() ? 'border-l-2 border-b border-black' : 'border-b border-gray-300']),
                          to: subRoute.path
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t(`${subRoute.name}`)), 1)
                          ]),
                          _: 2
                        }, 1032, ["to", "class"])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})